'use strict';

var React = require('react');

var SvgInactiveLocationMajor = function SvgInactiveLocationMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m16.477 3.33-3.67 3.67-3.827 3.829-4.474 4.473-2.983 2.983a1 1 0 1 0 1.414 1.415l2.853-2.853c.912.977 2.013 1.943 3.33 2.883.51.36 1.21.36 1.72 0 5.14-3.67 7-7.74 7.13-11.29.01-.15.01-.29.01-.44 0-.996-.182-1.95-.515-2.829l2.23-2.21a1 1 0 0 0-1.414-1.414l-1.804 1.784Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.98 0c1.955 0 3.746.7 5.135 1.865l-3.574 3.573a2.998 2.998 0 0 0-3.682.441 2.996 2.996 0 0 0-.441 3.683l-4.006 4.006c-.939-1.76-1.363-3.499-1.422-5.128-.01-.15-.01-.29-.01-.44 0-4.42 3.58-8 8-8Z"
  }));
};

exports.SvgInactiveLocationMajor = SvgInactiveLocationMajor;
